import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import { BrowserRouter } from 'react-router-dom';

document.body.setAttribute('data-floating-ui-scroll-lock', '');

// Suppress Floating UI warning in development
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('in not contained inside <body data-floating-ui-scroll-lock>')
    ) {
      return;
    }
    originalWarn.apply(console, args);
  };
}

// Replace with your actual Clerk frontend API key
const CLERK_PUBLISHABLE_KEY = 'pk_test_bWFnbmV0aWMtbW9ua2Zpc2gtNjMuY2xlcmsuYWNjb3VudHMuZGV2JA';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
    <BrowserRouter>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </ClerkProvider>
);

reportWebVitals();